module.exports = __webpack_public_path__ + "static/media/handshake-big.156b6eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/handshake-big.jpg
// module id = 135
// module chunks = 0